import { Box } from "@repo/components/src/ui/box";
import { Button, ButtonIcon, ButtonText } from "@repo/components/src/ui/button";
import { Icon } from "@repo/components/src/ui/icon";
import { Text } from "@repo/components/src/ui/text";
import { CloudOff, RefreshCw } from "lucide-react-native";
import React from "react";
import RNAnimated from "react-native-reanimated";

type BrandErrorScreenProps = {
  message?: string;
  onRetry: () => void;
  retrying: boolean;
};

const BrandErrorScreen = React.memo(
  ({ message, onRetry, retrying }: BrandErrorScreenProps) => (
    <Box className="flex-1 items-center justify-center bg-background-50 px-6">
      <Box className="items-center gap-8 max-w-md">
        <RNAnimated.View
          style={{
            animationName: {
              from: { transform: [{ translateY: 0 }] },
              to: { transform: [{ translateY: -6 }] },
            },
            animationDuration: "2s",
            animationTimingFunction: "ease-in-out",
            animationIterationCount: "infinite",
            animationDirection: "alternate",
          }}
        >
          <Box className="items-center justify-center w-20 h-20 rounded-full bg-error-50">
            <Icon as={CloudOff} className="w-10 h-10 text-error-500" />
          </Box>
        </RNAnimated.View>
        <Box className="items-center gap-3">
          <Text className="text-xl font-semibold text-center text-typography-900">
            No pudimos cargar tu perfil
          </Text>
          <Text className="text-sm text-center text-typography-500 leading-5">
            {message ??
              "Revisa tu conexión a internet e intenta nuevamente en un momento."}
          </Text>
        </Box>
        <Button
          onPress={onRetry}
          action="brand"
          variant="solid"
          size="lg"
          rounded="xl"
          isDisabled={retrying}
        >
          <ButtonIcon as={RefreshCw} />
          <ButtonText>{retrying ? "Reintentando..." : "Reintentar"}</ButtonText>
        </Button>
      </Box>
    </Box>
  ),
);
BrandErrorScreen.displayName = "BrandErrorScreen";

export default BrandErrorScreen;
